import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import imgUrl from '@/assets/others/index/bg.gif';
import { queryWastSiteStand, queryWastDateList, queryPipeSystem, queryManholeCover } from '@/api/api';
import Vue from 'vue';
import VueAMap from 'vue-amap'; //注意不要和 AMap原始名称覆盖

var amapManager = new VueAMap.AMapManager(); // 预警组件

import warn from '@/components/border/warn';
import border from '@/components/border/borderType'; // 达标率

import ball from '@/components/env-bigData/ball'; // 主要污染物

import pillar from '@/components/env-bigData/pillar'; //水质分布

import ratio from '@/components/env-bigData/ratio'; // 空气质量指数表盘图

import instrument from '@/components/env-bigData/instrument'; // 空气质量指数进度图

import barType from '@/components/env-bigData/barType';
import fileTable from '@/components/border/fileTable'; // 空气质量天数表盘图

import plate from '@/components/env-bigData/plate'; // 空气质量天数双表盘图

import doublePlate from '@/components/env-bigData/doublePlate';
import mapTag from "../com/mapTag";
import mapLegend from "../com/mapLegend.vue";
import { commonRender } from '@/mixins/commonRender';
import { queryRealtime, mainRealtime, querySiteList, queryStandardTreeList, queryWasteStand, queryWastRankSkylist, queryWastegasStand, queryWastesoilStand, queryAreaInfo } from '@/api/api';
import { getAction } from '@/api/manage';
import dial from '@/components/env-bigData/watch';
import Earth from '@/components/Map/earth';
export default {
  mixins: [commonRender],
  components: {
    mapLegend: mapLegend,
    Earth: Earth,
    border: border,
    dial: dial,
    ratio: ratio,
    warn: warn,
    ball: ball,
    pillar: pillar,
    fileTable: fileTable,
    instrument: instrument,
    barType: barType,
    plate: plate,
    doublePlate: doublePlate,
    mapTag: mapTag
  },
  data: function data() {
    return {
      district: null,
      citys: [],
      ratioWidth: '',
      ratioHeight: '',
      ballWidth: '',
      ballHeight: '',
      columnWidth: '',
      columnHeight: '',
      fileState: true,
      warnState: true,
      reportState: true,
      inlineRadio: '',
      tagList: [{
        'name': '',
        show: true,
        color: 'green',
        id: 0
      }, {
        'name': '',
        show: true,
        color: 'red',
        id: 0
      }],
      firstPollution: {},
      standLabel: '',
      standText: '',
      showState: true,
      selectIndex: '',
      standState: false,
      dateLists: [],
      windows: [],
      window: '',
      standardList: [],
      markerList: [],
      waterWarnList: [],
      // 日报数据
      dateList: [],
      // 水质分布数据
      standardMap: [],
      // 达标率
      compliant: 1,
      siteDetail: {},
      netSelectindex: 0,
      roadSelectindex: 0,
      mapControlindex: 0,
      time: [],
      labelData: [],
      pollutionData: [],
      amapManager: amapManager,
      center: [118.047928, 24.613341],
      // mapStyle: 'amap://styles/dark', //设置地图样式
      zoom: 15,
      markers: [{
        position: [120.726149, 29.951588]
      }],
      siteWarnList: [],
      mapSelectindex: 0,
      imgUrl: require("../../../../../assets/others/index/bg.gif"),
      wrongUrl: require("../../../../../assets/others/index/wrong.png"),
      plugin: [{
        pName: 'MapType',
        defaultType: 0,
        showRoad: false,
        showButton: false,
        showTraffic: false,
        events: {
          init: function init(o) {}
        }
      }],
      // tabList: [
      // 	// {
      // 	//   name: '水质监控',
      // 	//   type: 1,
      // 	// },
      // 	// {
      // 	//   name: '空气质量',
      // 	//   type: 2,
      // 	// },
      // 	// {
      // 	//   name: '土壤监控',
      // 	//   type: 3,
      // 	// },
      // 	{
      // 		name: '废水',
      // 		st: '32',
      // 		iconfont: 'icon-shuizhijiance',
      // 	},
      // 	{
      // 		name: '废气',
      // 		st: '31',
      // 		iconfont: 'icon-app_icons--',
      // 	},
      // 	{
      // 		name: '土壤',
      // 		st: '35',
      // 		iconfont: 'icon-turang',
      // 	},
      // ],
      selectType: '32',
      defaultValue: 1,
      pipeList: [],
      wellList: [],
      wellImg: require('@/assets/others/well.png'),
      pipeOffset: new AMap.Pixel(-20, -25)
    };
  },
  created: function created() {
    // setTimeout(()=>{
    // },500)
    // VueAMap.setZoom(3)
    this.center = window.localStorage.getItem('mapCenter') && window.localStorage.getItem('mapCenter') != 'null' ? window.localStorage.getItem('mapCenter').split(',') : [118.047928, 24.613341];

    if (window.localStorage.getItem('areaNameList') && window.localStorage.getItem('areaNameList') != 'null' && window.localStorage.getItem('areaNameList') != 'undefined') {
      this.citys = JSON.parse(window.localStorage.getItem('areaNameList'));
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      // this.selectIndex = this.tabList[0].st
      setTimeout(function () {
        _this.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage.getItem('mapZoom') : 12;
        var map = amapManager.getMap();

        _this.setMapTile(map);
      }, 1000);
    }); // setInterval(this.scroll, 1000)
    //自适应

    this.resetWidth();
    window.addEventListener('resize', function () {
      _this.resetWidth();
    }, false);
    this.getPipeSystem();
    this.getManholeCover();
  },
  methods: {
    // 获取所有管网数据
    getPipeSystem: function getPipeSystem() {
      var that = this;
      queryPipeSystem({
        current: 1,
        size: 1000000
      }).then(function (res) {
        if (res.success && res.result) {
          that.pipeList = res.result.records.map(function (item) {
            var pointList = item.coordinate.split(':');
            var lines = pointList.map(function (v) {
              return v.split('-').map(function (item) {
                return item.split(',');
              });
            });
            item.lines = lines;
            return item;
          });
        }
      });
    },
    // 获取所有窨井盖数据
    getManholeCover: function getManholeCover() {
      var _this2 = this;

      var that = this;
      queryManholeCover({
        current: 1,
        size: 1000000
      }).then(function (res) {
        if (res.success && res.result) {
          that.wellList = res.result.records.map(function (item) {
            return {
              id: item.id,
              position: item.coordinate.split(','),
              content: "<img style=\"width: 30px;height: 30px;\" src=\"".concat(_this2.wellImg, "\" />"),
              events: function events() {// 点击窨井盖
              }
            };
          });
        }
      });
    },
    drawBounds: function drawBounds() {
      var map = amapManager.getMap();
      var areaRoot = window.localStorage.getItem('areaRoot') && window.localStorage.getItem('areaRoot') != 'null' ? window.localStorage.getItem('areaRoot').split(',') : [];
      areaRoot.forEach(function (item) {
        queryAreaInfo(item).then(function (res) {
          if (res.success) {
            var features = [];

            if (res.result.mapStructure) {
              var pointList = JSON.parse(res.result.mapStructure).features.split(':');
              features = pointList.map(function (v) {
                return v.split('-').map(function (item) {
                  return item.split(',');
                });
              });
            }

            if (features.length > 0) {
              var outer = [new AMap.LngLat(-360, 90, true), new AMap.LngLat(-360, -90, true), new AMap.LngLat(360, -90, true), new AMap.LngLat(360, 90, true)];
              var inline = features.map(function (area) {
                return area.map(function (info) {
                  return new AMap.LngLat(info[0], info[1], true);
                });
              });
              var pathArray = [outer];
              pathArray.push.apply(pathArray, inline);
              var polygon = new AMap.Polygon({
                // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
                pathL: pathArray,
                //线条颜色，使用16进制颜色代码赋值。默认值为#006600
                strokeColor: 'rgb(20,164,173)',
                strokeWeight: 4,
                //轮廓线透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                strokeOpacity: 0.5,
                //多边形填充颜色，使用16进制颜色代码赋值，如：#FFAA00
                fillColor: 'rgba(99,99,99)',
                //多边形填充透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                fillOpacity: 0.3,
                zIndex: 99999999
              });
              polygon.setPath(pathArray);
              map.add(polygon); // features.forEach(area=>{
              //   var polygon = new AMap.Polygon({
              //     // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
              //     path: area,
              //     strokeColor: "#FF33FF",
              //     strokeWeight: 3,
              //     strokeOpacity: 0.5,
              //     fillOpacity: 0.3,
              //     fillColor: "#1791fc",
              //     zIndex: 99999999,
              //   });
              //   map.add(polygon);
              // })
            }
          }
        });
      });
    },
    resetWidth: function resetWidth() {
      this.$refs.ratioBorder.width = document.documentElement.clientWidth * 0.25;
      this.$refs.ratioBorder.height = document.documentElement.clientHeight * 0.275;
      this.$refs.ballBorder.width = document.documentElement.clientWidth * 0.25;
      this.$refs.ballBorder.height = document.documentElement.clientHeight * 0.275;
      this.$refs.columnBorder.width = document.documentElement.clientWidth * 0.25;
      this.$refs.columnBorder.height = document.documentElement.clientHeight * 0.275;
      this.$refs.warnBorder.width = document.documentElement.clientWidth * 0.28;
      this.$refs.warnBorder.height = document.documentElement.clientHeight * 0.5;
      this.$refs.warnBorder1.width = document.documentElement.clientWidth * 0.28;
      this.$refs.warnBorder1.height = document.documentElement.clientHeight * 0.34;
      this.ratioWidth = document.documentElement.clientWidth * 0.24 + 'px';
      this.ratioHeight = document.documentElement.clientHeight * 0.25 + 'px';
      this.ballWidth = document.documentElement.clientWidth * 0.25 + 'px';
      this.ballHeight = document.documentElement.clientHeight * 0.3 + 'px';
      this.columnWidth = document.documentElement.clientWidth * 0.25 + 'px';
      this.columnHeight = document.documentElement.clientHeight * 0.24 + 'px';
    },
    close: function close() {
      this.window.visible = false;
    },
    getApi: function getApi(st, radioSelected) {
      var _this3 = this;

      this.showState = false;
      this.$nextTick(function () {
        _this3.showState = true;
        _this3.defaultValue = 1;
        setTimeout(function () {
          _this3.getPollution(_this3.getDay(1), st);

          _this3.getData(st);

          _this3.getDateList(st);

          _this3.getStandard(st); // this.getSite(st)


          _this3.getWarn(radioSelected, st);

          _this3.drawBounds();
        }, 100);
      });
    },
    // 获取国标数据
    getStandard: function getStandard(st) {
      // queryStandardTreeList().then((res) => {
      // 	if (res.success) {
      // 		let arr = []
      // 		if (st == '32') {
      // 			res.result.forEach((item, index) => {
      // 				if (item.label == '国家标准') {
      // 					if (item.children != null) {
      // 						item.children.forEach((item1, index1) => {
      // 							if (item1.key == 'K1_3') {
      // 								arr = item1.children
      // 							}
      // 						})
      // 					}
      // 				}
      // 			})
      // 		} else {
      // 			res.result.forEach((item, index) => {
      // 				if (item.label == '国家标准') {
      // 					if (item.children != null) {
      // 						item.children.forEach((item1, index1) => {
      // 							if (item1.key == 'K1_2') {
      // 								arr = item1.children
      // 							}
      // 						})
      // 					}
      // 				}
      // 			})
      // 		}
      //
      // 		arr.forEach((item, index) => {
      // 			item.data.title = item.data.title.replace('类', '')
      // 			item.data.show = true
      // 			return item
      // 		})
      //
      // 	}
      // })
      var arr = [{
        name: '',
        title: '',
        children: [{
          data: {
            show: true,
            color: 'green',
            id: 'true',
            icon: this.selectIndex == '31' ? 'icon-feiqi' : 'icon-wushuifeishui',
            title: '达标'
          },
          title: '达标'
        }, {
          data: {
            show: true,
            color: 'red',
            id: 'false',
            icon: this.selectIndex == '31' ? 'icon-feiqi' : 'icon-wushuifeishui',
            title: '不达标'
          },
          title: '不达标'
        }]
      }];
      this.standardList = arr;
      this.getSite(st);
    },
    // 获取日报数据
    getDateList: function getDateList(st) {
      var _this4 = this;

      var params = {
        st: st
      };
      queryWastDateList(params).then(function (res) {
        if (res.success && res.result.records.length > 0) {
          var qualifiedArr = [];
          var disqualifiedArr = [];
          res.result.records.forEach(function (item, index) {
            if (item.attrs.upStandard) {
              qualifiedArr.push(item);
            } else {
              disqualifiedArr.push(item);
            }
          });
          _this4.dateList = [].concat(qualifiedArr, disqualifiedArr);
        } else {
          _this4.dateList = [];
        }
      });
    },
    // 获取一张图数据
    getData: function getData(st) {
      var _this5 = this;

      queryWastSiteStand({
        st: st
      }).then(function (res) {
        if (res.success) {
          var obj = {};
          var arr = [];

          for (var key in res.result.standardMap) {
            obj.name = key;
            obj.value = res.result.standardMap[key];
            arr.push(obj);
            obj = {};
          }

          _this5.standardMap = arr; // this.$refs.ratio.initBarChart(arr)

          if (res.result.totle > 0) {
            _this5.$refs.ball.initBarChart((res.result.compliant / res.result.totle).toFixed(4));
          } else {
            _this5.$refs.ball.initBarChart(0 .toFixed(4));
          }
        }
      });
    },
    scroll: function scroll() {
      var _this6 = this;

      setTimeout(function () {
        if (_this6.waterWarnList.length > 5) {
          _this6.waterWarnList.push(_this6.waterWarnList[0]); // 将数组的第一个元素添加到数组的


          _this6.waterWarnList.shift(); //删除数组的第一个元素

        }

        if (_this6.dateList.length > 13) {
          _this6.dateList.push(_this6.dateList[0]); // 将数组的第一个元素添加到数组的


          _this6.dateList.shift(); //删除数组的第一个元素

        }

        if (_this6.dateLists.length > 8) {
          _this6.dateLists.push(_this6.dateLists[0]); // 将数组的第一个元素添加到数组的


          _this6.dateLists.shift(); //删除数组的第一个元素

        }
      }, 500);
    }
  }
};